import { DacConfig } from "./dac-config.service";
import { Injectable } from "@angular/core";

@Injectable()
export class SsoCrossDomainMessenger {

    constructor(private dacConfig:DacConfig) {
    }

    sendMessage(type, sendData:any) {
        let data = Object.assign({}, sendData);
        data.type = type;
        // TODO: stephen do we want to whitelist the events here??
        if (this.dacConfig.seamlessMode && this.dacConfig.ssoIssuer) {
            // we are embedded in an iframe so let's post to our parent window
            if (window && window.document) {
              // TODO: stephen need to figure out the best way to post this message.
              window.parent.postMessage(data, this.dacConfig.ssoIssuer);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/sso-cross-domain-messenger.ts